import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCarmfAsv = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
        {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Carmf" && Carriere.ParamCotisations.ConventionneCarmf !== "non" )
                    .length > 0 && (
        <tr>
          <td>ASV CARMF</td>
          <td>
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarmf}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteSuppCarmf",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCarmfSupp}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCarmfSupp",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Carmf?.General?.AsvPointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Carmf?.General?.AsvPointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
      )}
    </>
  );
};
export default PointCarmfAsv;
